






















































import { Component, Vue, Prop } from 'vue-property-decorator'
import moment from 'moment'

const MONTH_NAMES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
const WEEK_DAYS = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb']
const ORDINALS = ['1ª', '2ª', '3ª', '4ª', '5ª']
const MAX_WEEKS_IN_MONTH = ORDINALS.length
const MAX_DAYS_IN_ANY_MONTH = 31
const ALL_WEEK_NUMBERS = Array.from({ length: MAX_WEEKS_IN_MONTH }, (_, index) => index + 1)

interface Semana {
  weekNumber: number,
  startDay: number,
  endDay: number,
  days: number[],
}

@Component
export default class RegraReservaSemanasDoMes extends Vue {
  @Prop({ default: () => [] }) value: number[]
  @Prop({ required: true }) referenceDate: string
  @Prop({ default: () => [] }) weekDays: number[]
  @Prop({ default: false }) disabled: boolean

  get momentReference() {
    const parsed = moment(this.referenceDate)
    return parsed.isValid() ? parsed : moment()
  }

  get monthLabel() {
    return `${MONTH_NAMES[this.momentReference.month()]} de ${this.momentReference.year()}`
  }

  get firstWeekdayOfMonth() {
    return this.momentReference.clone().date(1).day()
  }

  get weekDayHeaders() {
    return [...WEEK_DAYS.slice(this.firstWeekdayOfMonth), ...WEEK_DAYS.slice(0, this.firstWeekdayOfMonth)]
  }

  get weeks(): Semana[] {
    // Sempre desenha as 5 semanas (nenhum mês passa disso), mesmo que o mês de
    // referência tenha menos dias — senão fevereiro nunca deixaria escolher a
    // 5ª semana, que ainda vale pra outros meses da recorrência.
    return Array.from({ length: MAX_WEEKS_IN_MONTH }, (_, index) => {
      const weekNumber = index + 1
      const startDay = index * 7 + 1
      const endDay = Math.min(startDay + 6, MAX_DAYS_IN_ANY_MONTH)
      const days: number[] = []

      for (let day = startDay; day <= endDay; day += 1) days.push(day)

      return { weekNumber, startDay, endDay, days }
    })
  }

  existsInReferenceMonth(day: number) {
    return day <= this.momentReference.daysInMonth()
  }

  get hasOutsideMonthDays() {
    return this.momentReference.daysInMonth() < MAX_DAYS_IN_ANY_MONTH
  }

  paddedDays(week: Semana) {
    return week.days.length < 7 ? [...week.days, ...Array(7 - week.days.length).fill(null)] : week.days
  }

  ordinal(weekNumber: number) {
    return ORDINALS[weekNumber - 1] || `${weekNumber}ª`
  }

  isWeekSelected(weekNumber: number) {
    return this.value.length === 0 || this.value.includes(weekNumber)
  }

  dayOfWeek(day: number) {
    return this.momentReference.clone().date(day).day()
  }

  isHit(day: number, weekNumber: number) {
    if (!this.existsInReferenceMonth(day)) return false
    return this.isWeekSelected(weekNumber) && this.weekDays.length > 0 && this.weekDays.includes(this.dayOfWeek(day))
  }

  toggleWeek(weekNumber: number) {
    if (this.disabled) {
      this.$emit('disabled-click')
      return
    }

    const currentSelection = this.value.length === 0 ? [...ALL_WEEK_NUMBERS] : [...this.value]
    const alreadySelected = currentSelection.includes(weekNumber)

    if (alreadySelected && currentSelection.length <= 1) return

    const updated = alreadySelected
      ? currentSelection.filter(week => week !== weekNumber)
      : [...currentSelection, weekNumber].sort((a, b) => a - b)

    this.$emit('input', updated.length === MAX_WEEKS_IN_MONTH ? [] : updated)
  }

  get selectionSummary() {
    if (this.value.length === 0) return 'Aplica em todas as semanas do mês.'

    const semanas = [...this.value].sort((a, b) => a - b).map(week => this.ordinal(week))
    const descricao = semanas.length > 1
      ? `${semanas.slice(0, -1).join(', ')} e ${semanas[semanas.length - 1]}`
      : semanas[0]

    return `Aplica na ${descricao} semana do mês.`
  }
}
